import SsoVuexModule from "@abaco/sso-web-module/src/abaco-module/state";
import { HTTPClient, propsToDate } from "@abaco/web-common/src/HTTP";
import { BuyerContract, BuyerContractCompanyData, ContractUser, ContractUserOut, OrganisationThreshold } from "../farm-registry/models/Threshold";

const RPP = 25;

export default class ContractApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async existsSsoUser(username: string): Promise<boolean> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "gurl_services/exists_sso_user",
            userid: username
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].retcount > 0;
    }

    public async existsGuAccreditamento(username: string): Promise<boolean> {

        const url = "/siticatasto/dbgis-servlet/tl_data"
        const params = {
            svccode: "gurl_services/exists_gu_accreditamento",
            userid: username
        }

        const res = await this.http.get(url, { params })
        return res.data.services[0].entities[0].retcount > 0;
    }

    public async getBuyerContractSelf(userId: string): Promise<BuyerContract[]>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/getAllContractsForAdminUser/${userId}`, {
            params: {
                offset: 0,
                count: 300,
            },
        })
        return res.data.contract;
    }

    public async getContractUsers(contractId: number, subjectId: number): Promise<ContractUser[]>{
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/companies`, {
            params: {
                offset: 0,
                count: 300,
            },
        })
        const users = res.data && res.data.subjects && res.data.subjects.find((s: any) => s.subject.subject_id === subjectId).users ? res.data.subjects.find((s: any) => s.subject.subject_id === subjectId).users : [];
        return users;
    }

    async addUser(subjectId: number, contractId: number, detailForm: ContractUserOut){
        const form = {"subjectUsers": [detailForm]};
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/company/${subjectId}/users`, form)
        return res.data;
    }

    async getOrganisationThresholds(contractId: number): Promise<OrganisationThreshold> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/verifyOrganisations`);
        return res.data;
    }

    async getBuyerContractOrganisations(contractId: number): Promise<BuyerContractCompanyData> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/companies`);
        return res.data;
    }

    async deleteContractOrganisation(contractId: number, pkCuaa: number){
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/companies/${pkCuaa}`)
        return res.data;
    }
    async insertContractOrganisation(contractId: number, pkCuaa: number, date: Date){
        const form = {"activationDate": date.getTime()};
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/bc_business/contracts/${contractId}/companies/${pkCuaa}`, form)
        return res.data;
    }

}
